import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

import { ControlValueAccessor } from '@services/ui-services/control-value.accessor';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, ReactiveFormsModule, CeIconComponent, MatTooltipModule],
})
export class ToggleComponent extends ControlValueAccessor<boolean> {
  @Input() active = false;
  @Input() name = 'input_name';
  @Input() toggleLabel: string = '';
  @Input() info: string = '';
  @Input() help: boolean = false;
  @Input() disabled = false;
  @Input() size: 'medium' | 'large' = 'medium';
  @Input() id = Math.floor(Math.random() * (1000 - 1 + 1) + 1);
  @Input() isHandleToggle: boolean = true;

  public get classes(): string[] {
    let mode = 'statedefault';
    if (this.disabled) {
      mode = 'stateinactive';
    } else if (this.active) {
      mode = 'stateactive';
    }
    return [mode];
  }

  toggleActive() {
    if (this.disabled) {
      return;
    }

    if (this.isHandleToggle) {
      this.active = !this.active;
      this.onCheckChange.emit(this.active);
      this.onChange?.(this.active);
    }
  }

  @Output() onCheckChange = new EventEmitter<boolean>();

  // ControlValueAccessor callback sets intial control value to input
  writeValue(value: boolean): void {
    this.active = value;
  }

  // ControlValueAccessor callback for updading disable state in input from control
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
